/**
 * @param  {Location} location
 * @returns {boolean}
 */
export function appendHashLocationUtil (location, hash) {
  return (
    location?.pathname + location?.search + hash
  )
}
